<template>
  <div id="main-nav">
    <router-link to="/">
      <div id="homepage">
        <h2>ArenaWars</h2>
        <img src="~@/assets/swords.svg" alt="Arenawars-logo" />
      </div>
    </router-link>
    <a href="https://github.com/michaell92/Arena-wars" target="_blank">
      <h2>Github</h2>
    </a>
  </div>
</template>

<style scoped lang="scss">
</style>
